import { Observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";
import { WSFormGrid } from "../../../WSUtils/WSFormGrid";

export const CVEditApplicationStep = withWSErrorContainer(() => {
  return (
    <Observer
      render={() => {
        return (
          <CVEditApplicationStepStyles className="cve-application-step cve-step"></CVEditApplicationStepStyles>
        );
      }}
    />
  );
});

const CVEditApplicationStepStyles = styled(WSFormGrid)`
  &.cve-application-step {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;
  }
`;
